/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccommodationId_jsonld } from './AccommodationId_jsonld';
import type { CheapestRate_jsonld } from './CheapestRate_jsonld';
import type { Image_jsonld } from './Image_jsonld';
import type { InternalAmenityGroup_jsonld } from './InternalAmenityGroup_jsonld';
import type { InternalLabel_jsonld } from './InternalLabel_jsonld';
import type { Listing_jsonld } from './Listing_jsonld';
export type Accommodation_jsonld = {
    readonly '@id'?: string;
    readonly '@type'?: string;
    cheapestRate?: CheapestRate_jsonld | null;
    guaranteedPosition?: boolean;
    distance?: number | null;
    id?: string;
    name?: string;
    path?: string;
    settlementName?: string;
    longitude?: number | null;
    latitude?: number | null;
    ratingsAverage?: number | null;
    ratingsCount?: number;
    address?: string;
    type?: string;
    source?: string;
    currency?: string;
    streetNumber?: string | null;
    internalLabel?: InternalLabel_jsonld | null;
    internalAmenityGroups?: Array<InternalAmenityGroup_jsonld>;
    images?: Array<Image_jsonld>;
    listing?: Listing_jsonld | null;
    aboOta?: boolean;
    active?: boolean;
    foreignPartnerId?: number | null;
    ratingDescription?: Accommodation_jsonld.ratingDescription;
    caption?: string | null;
    distanceFromCenter?: number | null;
    bestseller?: boolean;
    sort?: any[] | null;
    postalCode?: string;
    isNocClone?: boolean;
    settlementId?: number | null;
    isFlagged?: boolean;
    placement?: Accommodation_jsonld.placement;
    readonly identifier?: AccommodationId_jsonld;
    readonly nocClone?: boolean;
    readonly flagged?: boolean;
};
export namespace Accommodation_jsonld {
    export enum ratingDescription {
        AVERAGE = 'average',
        DECENT = 'decent',
        GOOD = 'good',
        VERY_GOOD = 'veryGood',
        SENSATIONAL = 'sensational',
    }
    export enum placement {
        GUARANTEE = 'Guarantee',
        SORT = 'Sort',
        PLACEHOLDER = 'Placeholder',
        NEARBY = 'Nearby',
    }
}
